import { Action } from "@ngrx/store"
import { ArrearsCollection } from "../models/arrears-collection"
import { IContext } from "@context/models/context";
import { AdminArrearsDataModel } from "../models/admin-arrears-data.model";
import { ArrearsLabels } from '../models/arrears-labels.model';

export const LOAD = '[Arrears] Load';
export const LOAD_COMPLETE = '[Arrears] Load Complete';
export const LOAD_ERROR = '[Arrears] Load Error';
export const UPDATE_GROUPING = '[Arrears] Update Grouping';

export const LOAD_ADMIN_DATA = '[Arrears] Admin Data Load';
export const LOAD_ADMIN_DATA_COMPLETE = '[Arrears] Admin Data Complete';
export const LOAD_ADMIN_DATA_ERROR = '[Arrears] Admin Data Error';

export const LOAD_LABELS_COMPLETE = '[Arrears] Load Labels Complete';

export class LoadLabelsComplete implements Action {
  readonly type = LOAD_LABELS_COMPLETE;
  constructor(public payload: ArrearsLabels ) { }
}

export class Load implements Action {
  readonly type = LOAD;
  constructor(public context: IContext, public widgetId: string) { }
}
export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: ArrearsCollection, public widgetId: string) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;

  constructor(public payload: any, public widgetId: string) { }
}

export class UpdateGrouping implements Action {
  readonly type = UPDATE_GROUPING;
  constructor(public widgetId: string, public groupByField1: string, public groupByField2: string, public column1Header: string, public currency: string) { }
}

export class LoadAdminData implements Action {
  readonly type = LOAD_ADMIN_DATA;
  constructor() { }
}
export class LoadAdminDataComplete implements Action {
  readonly type = LOAD_ADMIN_DATA_COMPLETE;
  constructor(public payload: AdminArrearsDataModel) { }
}

export class LoadAdminDataError implements Action {
  readonly type = LOAD_ADMIN_DATA_ERROR;
  constructor(public payload: any) { }
}

export type Actions =
  Load |
  LoadComplete |
  LoadError |
  UpdateGrouping |
  LoadAdminData |
  LoadAdminDataComplete |
  LoadAdminDataError |
  LoadLabelsComplete;
